<template>
  <div class="suggestion">
    Did you mean: &nbsp;
    <a v-on:click="emitSuggestion()">{{ suggestion }}</a
    >?
  </div>
</template>

<script>
export default {
  name: "SearchQuerySuggest",
  data() {
    return {
      suggestion: ""
    };
  },
  props: {
    suggest: Object
  },
  watch: {
    suggest() {
      this.filterSuggestion();
    }
  },
  methods: {
    emitSuggestion() {
      this.$emit("update:suggested", {
        term: this.suggestion
      });
    },
    filterSuggestion() {
      this.suggestion = this.suggest?.suggestor?.[0]?.options?.[0]?.text || "";
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  color: $color__link;
  &:hover {
    text-decoration: underline;
  }
}
</style>
